<glxy-confirmation-body>
  <mat-icon glxyConfirmationIcon class="icon" inline="true" color="primary">info</mat-icon>

  <glxy-confirmation-title>
    {{ 'ASSOCIATION_PANEL.CONFIRM_EXISTING_PRIMARY_MODAL.TITLE' | translateByObjectType: objectType }}
  </glxy-confirmation-title>

  <glxy-confirmation-message>
    <p>
      {{ 'ASSOCIATION_PANEL.CONFIRM_EXISTING_PRIMARY_MODAL.CONFIRMATION_MESSAGE' | translateByObjectType: objectType }}
    </p>
    <ul>
      @for (association of associations; track association.crmObjectId) {
        @if (association?.crmObjectId && data.existingPrimaryObjectIds.includes(association?.crmObjectId)) {
          <li>{{ displayNamesByObjectId.get(association?.crmObjectId) }}</li>
        }
      }
    </ul>
  </glxy-confirmation-message>
</glxy-confirmation-body>

<glxy-confirmation-actions>
  <glxy-confirmation-primary-actions>
    <button mat-stroked-button (click)="cancel()">
      {{ 'ACTIONS.CANCEL' | translate }}
    </button>

    <button mat-flat-button color="primary" (click)="save()">
      {{ 'ACTIONS.ADD' | translate }}
    </button>
  </glxy-confirmation-primary-actions>
</glxy-confirmation-actions>
